import { GAClientConfig } from './ga-client.interface';

export interface AppProvidersConfig {
  gaTagsConfig: GAClientConfig;
}
